import {setMetadata} from '../../core/data-source/data-source';
import {HttpCrudDataSource, RestResponseRecord} from '../../core/data-source/http-crud.data-source';
import {fromJson, toJson} from '../../core/data-source/json.mapper';
import {httpService} from '../../core/services/http.service';

export class OrderItemCancellationReasonsCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/orderItemFailReasons';

    async save(records: T[]): Promise<T[]> {
        return httpService
            .post(
                this.apiPath,
                records.map((r: T) => toJson(r))
            )
            .then((response: any) => {
                if (response.data.success) {
                    return setMetadata(
                        response.data.rows.map((json: any) => fromJson(this.recordClass, json)),
                        fromJson(RestResponseRecord, response.data)
                    );
                } else {
                    throw response.data.errors;
                }
            });
    }
}
